import React, { useEffect, useState } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Select from "react-select"
// common
import Pagination from "components/Common/Pagination"
import {
  fetchNodeData,
  fetchData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"
import NewPagination from "components/Common/Newpagination"
import { symbol } from "prop-types"

function TableContainer({
  columns,
  data,
  getData,
  setLoading,
  colourStyles,
  currencyOptions,
}) {
  const [status, setStatus] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [serviceName, setServiceName] = useState("")
  const [price, setPrice] = useState("")
  const [serviceBox, setServiceBox] = useState(false)
  const [currency, setCurrency] = useState(null)
  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      colourStyles,
      currencyOptions,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  const navigate = useNavigate()

  const addService = async e => {
    e.preventDefault()

    const payload = {
      service_name: serviceName || "",
      price: price || "",
      service_box: serviceBox ? "yes" : "no", // convert boolean to yes/no for DB
      currency: currency?.value || "",
      symbol: currency?.symbol || "",
    }

    const response = await FetchNodePostData(
      setLoading,
      "hostingService/service/add",
      secureLocalStorage.getItem("auth_token"),
      payload
    )

    if (response?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Service Added Successfully",
        showConfirmButton: true,
      })
      setStatus(false)
      setServiceName("")
      setPrice("")
      setServiceBox(false)

      // refresh table
      getData()
    } else {
      Swal.fire({
        icon: "error",
        text: response?.data?.message || "Failed to add service",
      })
    }
  }

  return (
    <div className="px-2">
      {/* Fixed Buttons */}
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => setStatus(true)}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span>Service</span>
        </button>
        <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a>
      </div>

      {/* Table + Filters */}
      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  type="text"
                  className="border-radius form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className="border-radius btn btn-purple"
              onClick={() => setStatus(true)}
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add Services
            </a>
            <a
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </a>
          </div>
        </Col>
      </Row>

      {/* Table */}
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 1 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={`col-md-${index === 1 ? "4" : "2"}`}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>

      {/* Modal */}
      <Modal isOpen={status} size="sm" className="bd-custom-md-2" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Services</h5>
          <button
            type="button"
            onClick={() => {
              setServiceName("")
              setPrice("")
              setCurrency(null)
              setStatus(false)
            }}
            // onClick={() => setStatus(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row" onSubmit={addService}>
            <div className="mb-3 col-md-12">
              <Label>
                Service Name<span className="text-danger"> *</span>
              </Label>
              <Input
                type="text"
                className="form-control"
                placeholder="Enter Service Name"
                value={serviceName}
                onChange={e => setServiceName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3 col-md-6">
              {" "}
              <Label>Price</Label>{" "}
              <Input
                type="text"
                className="form-control"
                placeholder="Enter Price"
                value={price}
                onChange={e => setPrice(e.target.value)}
              />{" "}
            </div>

            <div className="mb-3 col-md-6">
              <label>Currency</label>
              <Select
                placeholder="Select Currency"
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  ...colourStyles,
                  container: base => ({ ...base, width: "100%" }),
                }}
                options={currencyOptions}
                value={currency}
                onChange={e => setCurrency(e)}
                formatOptionLabel={option => (
                  <div>
                    {option.label} {option.symbol}
                  </div>
                )}
              />
            </div>

            <div className="mb-2 col-md-12 display-flex align-item-center">
              <input
                type="checkbox"
                onChange={e => {
                  setServiceBox(e.target.checked)
                }}
              />
              <label className="pl-10 pt-10 col-md-10">Textbox Required</label>
            </div>

            <div className="mt-20">
              <button type="submit" className="border-radius btn btn-purple">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const HostingService = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [edit_status, setEditStatus] = useState(false)
  const [currencyOptions, setCurrencyOptions] = useState([])
  const [currency, setCurrency] = useState(null)
  // Edit states
  const [editId, setEditId] = useState(null)
  const [serviceName, setServiceName] = useState("")
  const [price, setPrice] = useState("")
  const [serviceBox, setServiceBox] = useState(false)

  // Fetch Data
  const getData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "hostingService/service/get",
      secureLocalStorage?.getItem("auth_token")
    )
    setData(response.data)
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    ;(async () => {
      const response = await fetchData(
        setLoading,
        "currency",
        secureLocalStorage?.getItem("auth_token")
      )
      if (response?.success) {
        const options = response?.data?.currency?.map(c => ({
          label: c.currency,
          value: c.currency,
          symbol: c.symbol,
        }))
        setCurrencyOptions(options)
      }
    })()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "id-width",
      },
      {
        Header: "Service Name",
        accessor: "service_name",
      },
      {
        Header: "Textbox",
        accessor: "service_box",
      },
      {
        Header: "Price",
        accessor: "price",
      },
      {
        Header: "Action",
        accessor: "action",
        className: "action-width",
        Cell: cellProps => {
          return (
            <div>
              <a
                onClick={() => {
                  EditService(cellProps?.row?.original)
                }}
                className="btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </a>
              <a
                onClick={() => {
                  DeletePackage(cellProps?.row?.original?.id)
                }}
                className="btn btn-sm  btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )

  const EditService = service => {
    setEditId(service.id)
    setServiceName(service.service_name || "")
    setPrice(service.price || "")
    setServiceBox(service.service_box == "yes") // assuming DB stores 1/0
    setCurrency(
      service.currency
        ? {
            label: service.currency,
            value: service.currency,
            symbol: service.symbol || "",
          }
        : null
    )
    setEditStatus(true)
  }

  const editHostingService = async e => {
    e.preventDefault()

    const payload = {
      service_name: serviceName,
      price: price,
      service_box: serviceBox ? "yes" : "no",
      currency: currency?.value || "", // add currency
      symbol: currency?.symbol || "",
    }

    const res = await FetchNodePutData(
      setLoading,
      "hostingService/service/edit",
      editId,
      payload
    )

    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Service Edited Successfully",
        showConfirmButton: true,
      })
      setEditStatus(false)
      getData()
    }
  }

  const DeletePackage = async id => {
    const response = await FetchNodeDeleteData(
      setLoading,
      "hostingService/service/delete",
      id
    )
    if (response?.data?.success) {
      getData()
      Swal.fire({ icon: "success", text: "Service Deleted Successfully" })
    } else {
      Swal.fire({
        icon: "error",
        text: response.data?.message || "Failed to delete service",
      })
    }
  }
  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 50,
    }),
  }

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data || []}
              getData={getData}
              setLoading={setLoading}
              currencyOptions={currencyOptions}
              colourStyles={colourStyles}
            />
          </div>
        </Col>

        <Modal
          isOpen={edit_status}
          size="sm"
          className="bd-custom-md-2"
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Edit Service</h5>
            <button
              type="button"
              // onClick={() => {
              //   setStatus(false)
              //   setServiceName("")
              //   setPrice("")
              //   setServiceBox(false)
              //   setEditStatus(false)
              // }}
              onClick={() =>   setEditStatus(false)}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row" onSubmit={editHostingService}>
              <div className="mb-3 col-md-12">
                <Label>
                  Service Name<span className="text-danger"> *</span>
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Enter Service Name"
                  value={serviceName}
                  onChange={e => setServiceName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3 col-md-6">
                <Label>Price</Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Enter Price"
                  value={
                    price
                  }
                  onChange={e => {
                    // Remove symbol if user types, store only numeric part
                    const val = e.target.value
                      .replace(currency?.symbol || "", "")
                      .trim()
                    setPrice(val)
                  }}
                />
              </div>

              <div className="mb-3 col-md-6">
                <label>Currency</label>
                <Select
                  placeholder="Select Currency"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    ...colourStyles,
                    container: base => ({ ...base, width: "100%" }),
                  }}
                  options={currencyOptions}
                  value={currency}
                  onChange={e => setCurrency(e)} // e contains {label, value, symbol}
                  formatOptionLabel={option => (
                    <div>
                      {option.label} {option.symbol}
                    </div>
                  )}
                />
              </div>

              <div className="mb-2 col-md-12 display-flex align-item-center">
                <input
                  type="checkbox"
                  checked={serviceBox}
                  onChange={e => setServiceBox(e.target.checked)}
                />
                <label className="pl-10 pt-10 col-md-10">
                  Textbox Required
                </label>
              </div>

              <div className="mt-20">
                <button className="border-radius btn btn-purple">Submit</button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </div>
  )
}

export default HostingService
